// import configdata from "./config.json";
// import httpService from "./httpService.js";

// let apiEndpoint = "";

// if (process.env.NODE_ENV !== "production") {
//   apiEndpoint = `${configdata.apiUrl}/detectors`;

// } else {
//   apiEndpoint = `${configdata.apiUrl}/detectors`;

// }

// export async function getCheckSummariser(input) {
//   const cleanedText = input.text.replace(/.*\t.*/g, '').trim();
//   input.text = cleanedText
//   const data = await httpService.post(`${apiEndpoint}/checkSummarizer`, {
//     input
//   });
//   return data;
// }

// export async function summarizerKeywords(text) {
//   const data = await httpService.post(`${apiEndpoint}/summarizerKeywords`, {
//     text
//   });
//   return data;
// }



// export async function Summarizer_Perc(text) {
//   const data = await httpService.post(`${apiEndpoint}/Summarizer_Length_Perc`, {
//     text
//   });
//   return data;
// }


// export default {
//   getCheckSummariser,
//   summarizerKeywords,
//   Summarizer_Perc

// }


import configdata from "./config.json";
import httpService from "./httpService.js";

let apiEndpoint = "";

if (process.env.NODE_ENV !== "production") {
  apiEndpoint = `${configdata.apiUrl}/detectors`;
} else {
  apiEndpoint = `${configdata.apiUrl}/detectors`;
}

// ==================== EXISTING SUMMARIZER APIs ====================

export async function getCheckSummariser(input) {
  const cleanedText = input.text.replace(/.*\t.*/g, '').trim();
  input.text = cleanedText;
  const data = await httpService.post(`${apiEndpoint}/checkSummarizer`, {
    input
  });
  return data;
}

export async function summarizerKeywords(text) {
  const data = await httpService.post(`${apiEndpoint}/summarizerKeywords`, {
    text
  });
  return data;
}

export async function Summarizer_Perc(text) {
  const data = await httpService.post(`${apiEndpoint}/Summarizer_Length_Perc`, {
    text
  });
  return data;
}

// ==================== NEW SUMMARY HISTORY APIs ====================

// Save a summary to history
export async function saveSummaryToHistory(summaryData) {
  try {
    const data = await httpService.post(`${apiEndpoint}/save`, summaryData);
    return data;
  } catch (error) {
    console.error("Error saving summary to history:", error);
    throw error;
  }
}

// Get user's summary history
export async function getSummaryHistory(userId, machineId) {
  try {
    const data = await httpService.post(`${apiEndpoint}/history`, {
      userId,
      machineId
    });
    return data;
  } catch (error) {
    console.error("Error fetching summary history:", error);
    throw error;
  }
}

// Update a summary in history
export async function updateSummaryInHistory(id, outputText) {
  try {
    const data = await httpService.put(`${apiEndpoint}/update/${id}`, {
      outputText
    });
    return data;
  } catch (error) {
    console.error("Error updating summary:", error);
    throw error;
  }
}

// Delete a summary from history
export async function deleteSummaryFromHistory(id) {
  try {
    const data = await httpService.delete(`${apiEndpoint}/delete/${id}`);
    return data;
  } catch (error) {
    console.error("Error deleting summary:", error);
    throw error;
  }
}

// ==================== BATCH OPERATIONS (Optional) ====================

// Delete multiple summaries
export async function deleteMultipleSummaries(summaryIds) {
  try {
    // If you have a bulk delete endpoint
    const promises = summaryIds.map(id => deleteSummaryFromHistory(id));
    const results = await Promise.all(promises);
    return results;
  } catch (error) {
    console.error("Error deleting multiple summaries:", error);
    throw error;
  }
}

// Get summary statistics
export async function getSummaryStatistics(userId, machineId) {
  try {
    const history = await getSummaryHistory(userId, machineId);
    if (history.success && history.data) {
      const summaries = history.data;
      const stats = {
        totalSummaries: summaries.length,
        totalWords: summaries.reduce((sum, s) => sum + (s.wordCount || 0), 0),
        averageWords: summaries.length > 0 
          ? Math.round(summaries.reduce((sum, s) => sum + (s.wordCount || 0), 0) / summaries.length)
          : 0,
        byType: summaries.reduce((acc, s) => {
          acc[s.type] = (acc[s.type] || 0) + 1;
          return acc;
        }, {}),
        last7Days: summaries.filter(s => {
          const daysDiff = (new Date() - new Date(s.createdAt)) / (1000 * 60 * 60 * 24);
          return daysDiff <= 7;
        }).length
      };
      return { success: true, data: stats };
    }
    return { success: false, data: null };
  } catch (error) {
    console.error("Error getting summary statistics:", error);
    throw error;
  }
}

// Search in history
export async function searchInHistory(userId, machineId, searchTerm) {
  try {
    const history = await getSummaryHistory(userId, machineId);
    if (history.success && history.data) {
      const filtered = history.data.filter(summary => 
        summary.originalText?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        summary.outputText?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        summary.type?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      return { success: true, data: filtered };
    }
    return { success: false, data: [] };
  } catch (error) {
    console.error("Error searching in history:", error);
    throw error;
  }
}

// Export all functions
export default {
  // Existing
  getCheckSummariser,
  summarizerKeywords,
  Summarizer_Perc,
  
  // New history APIs
  saveSummaryToHistory,
  getSummaryHistory,
  updateSummaryInHistory,
  deleteSummaryFromHistory,
  deleteMultipleSummaries,
  getSummaryStatistics,
  searchInHistory
};